import React from 'react';
import { UpcomingShiftsAdmin } from './UpcomingShiftsAdmin';
import { UpcomingShiftsVolunteer } from './UpcomingShiftsVolunteer';
export const UpcomingShifts = ({ shifts, missionId, missionStatus, missionOrganizationSharing, isVolunteerView, onRequestParticipation, onSelfWithdrawal, onFetchShifts, }) => {
    if (!isVolunteerView) {
        return (React.createElement(UpcomingShiftsAdmin, { shifts: shifts, missionId: missionId, missionStatus: missionStatus, missionOrganizationSharing: missionOrganizationSharing, onFetchShifts: onFetchShifts }));
    }
    return (React.createElement(UpcomingShiftsVolunteer, { shifts: shifts, missionStatus: missionStatus, onSelfWithdrawal: onSelfWithdrawal, onRequestParticipation: onRequestParticipation, onFetchShifts: onFetchShifts }));
};
